//@ts-nocheck
import {
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useFormsetDrawer } from "./hooks";
import { AddIcon } from "@chakra-ui/icons";
import { observer } from "mobx-react-lite";
import { useOverlayDisclosure } from "../../../components/OverlayRouter";

type FormsetFormDrawerProps = {
  values: Array<any>;
  formIndex: any;
  isOpen: boolean;
  onClose: any;
  onRemove: any;
  onSaveEdit?: (values: any) => Promise<any>;
  Form: any;
  drawerHeaderText: any;
  saveButtonText: string;
  additionalFormProps: any;
  validateForm: (state: any) => boolean;
  defaultValue: any;
  isLoading?: boolean;
  isModal?: boolean;
  isMobile?: boolean;
};
export const FormsetFormDrawer = observer(
  ({
    values = [],
    formIndex,
    isOpen,
    onClose,
    onRemove,
    onSaveEdit,
    Form: PassedForm,
    drawerHeaderText,
    saveButtonText,
    isLoading,
    additionalFormProps = {},
    defaultValue = {},
    validateForm,
    isModal = true,
    isMobile,
  }: FormsetFormDrawerProps) => {
    const { controlActions, formikFormRef, formVals, onSubmit } =
      useFormsetDrawer({
        values,
        formIndex,
        onClose,
        onRemove,
        onSaveEdit,
        saveButtonText,
        isLoading,
        defaultValue,
        validateForm,
        isModal,
      });

    return (
      <ModalDrawerContainer
        {...{
          isModal,
          controlActions,
          isOpen,
          onClose,
          headerText: drawerHeaderText,
          isMobile,
        }}
      >
        <PassedForm
          value={formVals}
          innerRef={formikFormRef}
          onSubmit={onSubmit}
          {...additionalFormProps}
        />
      </ModalDrawerContainer>
    );
  }
);

type ModalDrawerContainerProps = {
  children: React.ReactNode;
  isMobile?: boolean;
  isModal?: boolean;
  headerText?: string;
  isOpen: boolean;
  onClose: () => void;
  controlActions?: React.ReactNode;
};
const ModalDrawerContainer = ({
  children,
  isMobile,
  controlActions,
  isModal = true,
  ...props
}: ModalDrawerContainerProps) => {
  return isModal ? (
    <>
      {isMobile ? (
        <Drawer
          isOpen={props.isOpen}
          placement="right"
          onClose={props.onClose}
          size="full"
          isFullHeight
        >
          <DrawerOverlay />
          <DrawerContent overflow="auto">
            <DrawerCloseButton />
            <DrawerHeader borderBottomWidth="2xs" borderColor="neutral.500">
              {props.headerText}
            </DrawerHeader>

            <DrawerBody py={6}>{children}</DrawerBody>

            <DrawerFooter
              d="block"
              borderTopWidth="2xs"
              borderColor="neutral.500"
            >
              {controlActions}
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      ) : (
        <Modal isOpen={props.isOpen} onClose={props.onClose} size="xl">
          <ModalOverlay />
          <ModalContent overflow="auto" rounded="lg">
            <ModalCloseButton zIndex="modal" />
            <ModalHeader>{props.headerText}</ModalHeader>

            <ModalBody pb={8} pt={3}>
              {children}
            </ModalBody>

            <ModalFooter d="block">{controlActions}</ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  ) : (
    <Stack spacing={6}>
      <Heading>{props.headerText}</Heading>
      {children}
      {controlActions}
    </Stack>
  );
};
//This shows the summary on the right on desktop
export const FormsetFormSummary = observer(
  ({
    formsetValue = [],
    onEdit,
    Component,
    ...rest
  }: {
    formsetValue: Array<any>;
    onEdit: (index: number) => void;
    Component: any;
  }) => {
    return (
      <Box {...rest}>
        {formsetValue.map((form, index) => (
          <Box key={index}>
            <Component field={form} onEdit={() => onEdit(index)} />
            {index !== formsetValue.length - 1 && (
              <Divider borderColor="neutral.500" my={[5, 6]} />
            )}
          </Box>
        ))}
      </Box>
    );
  }
);
function useReactRouterDisclosure(path: any, currentIndex?: any) {
  const [formIndex, setFormIndex] = useState<number | undefined>(currentIndex);
  const {
    isOpen,
    // onClose,
    // onOpen,
    rawOpen: onOpen,
    rawClose: onClose,
  }: {
    isOpen: boolean;
    onClose: () => void;
    onOpen: (customPath?: any) => void;
  } = useOverlayDisclosure(path);

  function onEdit(index: any) {
    setFormIndex(index);
    onOpen();
  }

  return { onOpen, isOpen, onClose, onEdit, formIndex, path };
}

function useSimpleDisclosure(path?: any, currentIndex?: any) {
  const [formIndex, setFormIndex] = useState<number | undefined>(currentIndex);
  const { isOpen, onClose, onOpen } = useDisclosure();

  function onEdit(index: any) {
    setFormIndex(index);
    onOpen();
  }

  return { onOpen, isOpen, onClose, onEdit, formIndex, path };
}

export type UseFormsetType<T = any> = {
  formsetValues?: any;
  Component?: any;
  onEdit?: any;
  addButtonText?: any;
  onAdd?: any;
  onSave?: (values: any) => Promise<any>;
  validateForm: (state: T) => boolean;
  ComponentForm?: any;
  FormSummary?: typeof FormsetFormSummary;
  currentFormIndex?: any;
  isLoading?: boolean;
  formDefaultValue?: any;
  additionalFormProps?: any;
  onRemove?: any;
  formHeaderText?: any;
  saveButtontext: string;
  leaveText?: string;
  removeAddButton?: boolean;
  onLeave?: () => any;
  isModal?: boolean;
  isMobile?: boolean;
  path?: string | null;
};

export function useFormset({
  formsetValues,
  Component,
  onEdit,
  addButtonText,
  onAdd,
  onSave,
  ComponentForm,
  currentFormIndex,
  formDefaultValue = {},
  additionalFormProps = {},
  onRemove,
  formHeaderText,
  isLoading,
  saveButtontext,
  removeAddButton,
  validateForm,
  leaveText,
  FormSummary = FormsetFormSummary,
  onLeave,
  // editFormInArray,
  isModal = true,
  isMobile,
  path = "/detail",
}: UseFormsetType) {
  const editFormInArray = path
    ? useReactRouterDisclosure(path, currentFormIndex)
    : useSimpleDisclosure(path, currentFormIndex);

  const formSummary = (
    <Stack spacing={[5, 6]}>
      {formsetValues.length > 0 && (
        <FormSummary
          formsetValue={formsetValues}
          Component={Component}
          onEdit={(passedIndex: any) => {
            onEdit(passedIndex);
            editFormInArray.onEdit(passedIndex);
          }}
        />
      )}

      {formsetValues.length > 0 && <Divider borderColor="neutral.500" pb={3} />}
      <Flex justifyContent={"space-between"}>
        {removeAddButton ? null : (
          <Button
            alignSelf="flex-start"
            variant="outline"
            colorScheme="blue"
            leftIcon={<AddIcon />}
            onClick={() => {
              onAdd();
              editFormInArray.onEdit(-1);
            }}
          >
            {addButtonText}
          </Button>
        )}
        {onLeave && (
          <Button alignSelf="flex-end" colorScheme="blue" onClick={onLeave}>
            {leaveText}
          </Button>
        )}
      </Flex>
    </Stack>
  );
  const drawerForm = (
    <FormsetFormDrawer
      onSaveEdit={onSave}
      validateForm={validateForm}
      Form={ComponentForm}
      isLoading={isLoading}
      key={additionalFormProps.length}
      additionalFormProps={additionalFormProps}
      drawerHeaderText={formHeaderText}
      values={formsetValues}
      defaultValue={formDefaultValue}
      saveButtonText={saveButtontext}
      onRemove={onRemove}
      isModal={isModal}
      isMobile={isMobile}
      {...editFormInArray}
    />
  );
  return {
    formSummary,
    drawerForm,
  };
}
